// Taste feedback copy (R-14 app half, 10/08/26): drafted by Astra (copy lane, build/astra/copy-taste-feedback-prompt.md ->
// copy-taste-feedback.txt; round 2 copy-taste-feedback-r2.txt for the challenge midpoint; copy-nfm-undo.txt for the Undo, 10/13), gated by Claude 10/08/26: every key present,
// placeholders kept, sentence case, no dashes / exclamation marks / AI words / "listings" / brackets. Do not edit by hand: a line
// that needs to change goes back to Astra. Its own file so the feature merges cleanly with copy.ts / copyFlow2.ts / copyV3.ts edits.
export const TF = {
  "tf.more_short": "More of this",
  "tf.less_short": "Less of this",
  "tf.nfm_short": "Not for me",
  "tf.more": "More like this",
  "tf.less": "Less like this",
  "tf.nfm": "Not for me",
  "tf.more_done": "Got it",
  "tf.less_done": "Got it",
  "tf.nfm_gone": "You won't see {title} again unless you undo.",
  "tf.nfm_undo": "Undo",
  "tf.nfm_back": "It's back.",
  "tf.nfm_undo_error": "Couldn't bring it back. Try again.",
  "tf.why": "What didn't fit? (optional)",
  "tf.r.too_far": "Too far",
  "tf.r.too_late": "Too late",
  "tf.r.too_pricey": "Too pricey",
  "tf.r.wrong_day": "Wrong day",
  "tf.r.been_there": "Been there",
  "tf.r.sold_out": "Sold out",
  "tf.r.no_time": "No time",
  "tf.r.too_crowded": "Too crowded",
  "tf.r.wrong_vibe": "Wrong vibe",
  "tf.r.not_my_thing": "Not my thing",
  "tf.r.too_touristy": "Too touristy",
  "tf.r.seen_enough": "Seen enough",
  "tf.thanks": "Thanks, that helps",
  "tf.close": "Close feedback",
  "tf.error": "That didn't go through. Try again.",
  "tf.explore": "Something new for you",
  "tf.ci_count_one": "1 outing to check in on",
  "tf.ci_count_other": "{count} outings to check in on",
  "tf.ci_question": "Did you go to {title}?",
  "tf.ci_yes": "Yes, I went",
  "tf.ci_no": "Didn't go",
  "tf.ci_skip": "Ask me later",
  "tf.ci_no_thanks": "Got it, thanks",
  "tf.ci_done": "That's all for now",
  "tf.pad_title": "How was {title}?",
  "tf.pad_hint": "One tap anywhere in the square answers both questions.",
  "tf.pad_x_low": "Didn't like it",
  "tf.pad_x_high": "Loved it",
  "tf.pad_unsure": "Not sure",
  "tf.pad_mid": "Somewhere in between",
  "tf.pad_q.connection": "Was it social?",
  "tf.pad_lo.connection": "On my own",
  "tf.pad_hi.connection": "Met people",
  "tf.pad_q.again": "Would you go back?",
  "tf.pad_lo.again": "Once was enough",
  "tf.pad_hi.again": "Would go again",
  "tf.pad_q.worth": "Was it worth what it cost?",
  "tf.pad_lo.worth": "Not worth it",
  "tf.pad_hi.worth": "Worth the price",
  "tf.pad_q.learned": "Did you learn anything?",
  "tf.pad_lo.learned": "Nothing new",
  "tf.pad_hi.learned": "Learned something",
  "tf.pad_q.challenge": "How hard was it?",
  "tf.pad_lo.challenge": "Too easy",
  "tf.pad_hi.challenge": "Too hard",
  "tf.pad_send": "Send",
  "tf.pad_retap": "Tap again to move the dot.",
  "tf.pad_thanks": "Thanks, that helps",
  "tf.pad_error": "That didn't go through. Try again.",
  "tf.pad_mid.challenge": "Just right",
} as const

export type TfKey = keyof typeof TF
/** A taste-feedback line, with {placeholders} filled. */
export const tf = (k: TfKey, vars: Record<string, string | number> = {}): string =>
  TF[k].replace(/\{(\w+)\}/g, (m, name: string) => (name in vars ? String(vars[name]) : m))
